<div class="tool-sso-container" *ngIf="!isLoadingLabels">
	<div class="header-wrap">
		<span class="tab" [ngClass]="{ selected: selectedTab === 'management' }" (click)="selectedTab = 'management'">{{
			labels.lbl_geral_gerenciamento_de_sso
		}}</span>
		<span class="tab" [ngClass]="{ selected: selectedTab === 'create' }" (click)="selectedTab = 'create'">{{
			labels.lbl_kb_criar
		}}</span>
	</div>
	<div class="body-wrap">
		<ng-container *ngIf="!isLoadingSSO">
			<ng-container *ngIf="selectedTab === 'management'">
				<div class="content-container">
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_pesquisar }}</span>
						<input
							type="text"
							[placeholder]="labels.lbl_geral_pesquisar"
							[value]="searchText"
							(input)="searchText = $event.target.value; searchItems()" />
					</div>
					<div class="table-container">
						<table>
							<thead>
								<tr>
									<th>{{ labels.lbl_geral_nome }}</th>
									<th>Hash</th>
									<th>{{ labels.lbl_geral_dominio }}</th>
									<th>{{ labels.lbl_geral_pagina }}</th>
									<th>{{ labels.lbl_geral_pagina_logout }}</th>
									<th>{{ labels.lbl_geral_pagina_de_redirecionamento }}</th>
									<th>{{ labels.lbl_bulletin_actions }}</th>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngIf="filteredItems.length > 0; else showAll">
									<tr class="select-bond" *ngFor="let item of filteredItems; let indexItem = index">
										<td class="truncate-text" [title]="item.customer_name">{{ item.customer_name }}</td>
										<td class="truncate-text" [title]="item.customer_hash">
											{{ item.customer_hash }}
										</td>
										<td class="truncate-text" [title]="item.customer_domain">{{ item.customer_domain }}</td>
										<td class="truncate-text" [title]="item.customer_page">{{ item.customer_page }}</td>
										<td class="truncate-text" [title]="item.logout_page">{{ item.logout_page }}</td>
										<td class="truncate-text" [title]="item.redirect_page">{{ item.redirect_page }}</td>
										<td>
											<fa-icon [icon]="icons.faPencil" (click)="openUpdatedForm(item)"></fa-icon>
											&nbsp;&nbsp;
											<span
												class="red-trash-icon"
												(click)="
													deleteListRef.classList.contains('confirm')
														? deleteSSO(item.customer_hash)
														: confirmButton(deleteListRef)
												"
												#deleteListRef>
												<fa-icon [icon]="icons.faTrash"></fa-icon>
											</span>
										</td>
									</tr>
								</ng-container>
								<ng-template #showAll>
									<tr class="select-bond" *ngFor="let item of ssoList; let indexItem = index">
										<td class="truncate-text" [title]="item.customer_name">{{ item.customer_name }}</td>
										<td class="truncate-text" [title]="item.customer_hash">
											{{ item.customer_hash }}
										</td>
										<td class="truncate-text" [title]="item.customer_domain">{{ item.customer_domain }}</td>
										<td class="truncate-text" [title]="item.customer_page">{{ item.customer_page }}</td>
										<td class="truncate-text" [title]="item.logout_page">{{ item.logout_page }}</td>
										<td class="truncate-text" [title]="item.redirect_page">{{ item.redirect_page }}</td>
										<td>
											<fa-icon [icon]="icons.faPencil" (click)="openUpdatedForm(item)"></fa-icon>
											&nbsp;&nbsp;
											<span
												class="red-trash-icon"
												(click)="
													deleteListRef.classList.contains('confirm')
														? deleteSSO(item.customer_hash)
														: confirmButton(deleteListRef)
												"
												#deleteListRef>
												<fa-icon [icon]="icons.faTrash"></fa-icon>
											</span>
										</td>
									</tr>
								</ng-template>
							</tbody>
						</table>
					</div>
				</div>

				<div class="content-container" *ngIf="showEditForm">
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_nome }} *</span>
						<input
							id="customer_name"
							name="customer_name"
							type="text"
							[(ngModel)]="formUpdate.customer_name"
							placeholder="{{ labels.lbl_geral_nome }}"
							readonly />
					</div>
					<div class="dotted-input-container">
						<span>Hash *</span>
						<input
							id="customer_hash"
							name="customer_hash"
							type="text"
							[(ngModel)]="formUpdate.customer_hash"
							placeholder="Hash"
							readonly />
					</div>
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_pagina }}</span>
						<input
							id="customer_page"
							name="customer_page"
							type="text"
							[(ngModel)]="formUpdate.customer_page"
							placeholder="{{ labels.lbl_geral_pagina }}" />
					</div>
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_pagina_logout }}</span>
						<input
							id="logout_page"
							name="logout_page"
							type="text"
							[(ngModel)]="formUpdate.logout_page"
							placeholder="{{ labels.lbl_geral_pagina_logout }}" />
					</div>
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_dominio }}</span>
						<input
							id="customer_domain"
							name="customer_domain"
							type="text"
							[(ngModel)]="formUpdate.customer_domain"
							placeholder="{{ labels.lbl_geral_dominio }}" />
					</div>
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_pagina_de_redirecionamento }}</span>
						<input
							id="redirect_page"
							name="redirect_page"
							type="text"
							[(ngModel)]="formUpdate.redirect_page"
							placeholder="{{ labels.lbl_geral_pagina_de_redirecionamento }}" />
					</div>

					<div class="button-container">
						<div class="button" [ngClass]="{ disabled: isUpdating }" (click)="updateSSO(formUpdate)">
							{{ labels.lbl_geral_atualizar }}
							<cpi-dot-bounce-loading-effect
								[color]="'var(--const-white)'"
								*ngIf="isUpdating"></cpi-dot-bounce-loading-effect>
						</div>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="selectedTab === 'create'">
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_nome }}*</span>
					<input
						id="customer_name"
						name="customer_name"
						type="text"
						[(ngModel)]="form.customer_name"
						placeholder="{{ labels.lbl_geral_nome }}" />
				</div>
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_pagina }}</span>
					<input
						id="customer_page"
						name="customer_page"
						type="text"
						[(ngModel)]="form.customer_page"
						placeholder="{{ labels.lbl_geral_pagina }}" />
				</div>
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_pagina_logout }}</span>
					<input
						id="logout_page"
						name="logout_page"
						type="text"
						[(ngModel)]="form.logout_page"
						placeholder="{{ labels.lbl_geral_pagina_logout }}" />
				</div>
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_dominio }}</span>
					<input
						id="customer_domain"
						name="customer_domain"
						type="text"
						[(ngModel)]="form.customer_domain"
						placeholder="{{ labels.lbl_geral_dominio }}" />
				</div>
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_pagina_de_redirecionamento }}</span>
					<input
						id="redirect_page"
						name="redirect_page"
						type="text"
						[(ngModel)]="form.redirect_page"
						placeholder="{{ labels.lbl_geral_pagina_de_redirecionamento }}" />
				</div>
				<div class="button-container">
					<div class="button" [ngClass]="{ disabled: isUpdating }" (click)="createSSO(form)">
						{{ labels.lbl_geral_salvar }}
						<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdating"></cpi-dot-bounce-loading-effect>
					</div>
				</div>
			</ng-container>
		</ng-container>

		<cpi-dot-bounce-loading-effect *ngIf="isLoadingSSO" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
	</div>
</div>

<cpi-dot-bounce-loading-effect *ngIf="isLoadingLabels" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
